"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.SudoPolicy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes"
            },
            {
                internalType: "enum Enum.Operation",
                name: "",
                type: "uint8"
            },
        ],
        name: "executeAndRevert",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "pure",
        type: "function"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610160806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c8063940d3c6014610030575b600080fd5b61004961003e366004610071565b600195945050505050565b604051901515815260200160405180910390f35b80356002811061006c57600080fd5b919050565b60008060008060006080868803121561008957600080fd5b853573ffffffffffffffffffffffffffffffffffffffff811681146100ad57600080fd5b945060208601359350604086013567ffffffffffffffff808211156100d157600080fd5b818801915088601f8301126100e557600080fd5b8135818111156100f457600080fd5b89602082850101111561010657600080fd5b60208301955080945050505061011e6060870161005d565b9050929550929590935056fea26469706673582212208fda2c43c114281e871e99a66a55f398a3c2536f1324cc081621c6ce7c45994264736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var SudoPolicy__factory = /** @class */ (function (_super) {
    __extends(SudoPolicy__factory, _super);
    function SudoPolicy__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    SudoPolicy__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SudoPolicy__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SudoPolicy__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SudoPolicy__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SudoPolicy__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    SudoPolicy__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    SudoPolicy__factory.bytecode = _bytecode;
    SudoPolicy__factory.abi = _abi;
    return SudoPolicy__factory;
}(ethers_1.ContractFactory));
exports.SudoPolicy__factory = SudoPolicy__factory;
